import { isWithinDateRangeUTC } from '../isWithinDateRangeUTC';

export const isCurrentlyWithinDateRangeUTC = (
  startUtcString: string,
  endUtcString: string,
) => {
  if (!startUtcString || !endUtcString) return false;

  return isWithinDateRangeUTC(new Date(), startUtcString, endUtcString);
};
